

















import { Component, Vue } from 'vue-property-decorator'
import { QBanner, QBtn, QIcon } from 'quasar'

@Component({
  components: {
    QBanner,
    QBtn,
    QIcon,
  },
})
export default class WarningBanner extends Vue {
  public hideWarning = false
}
